import { BottomAction } from '@euler/app/components/BottomAction';
import { WebContent } from '@euler/app/components/WebContent';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useTermsOfServiceHtmlSource } from '@euler/functions/tos/useTermsOfServiceHtmlSource';

import {
  useGeneralBottomSheetHeight,
  useGeneralBottomSheetModal,
} from '@euler/functions/useBottomSheetModal';
import {
  BottomSheetFooter,
  BottomSheetFooterProps,
  BottomSheetModal,
} from '@gorhom/bottom-sheet';
import { memo, useCallback } from 'react';
import { View } from 'react-native';
import {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated';

type Props = {
  isVisible?: boolean;
  onConfirm?: () => void;
  onDismiss?: () => void;
};

export const ServiceAgreementForSignatureModal = memo(
  ({ isVisible, onConfirm, onDismiss }: Props) => {
    const { rpx } = useResponsiveContext();

    const { bottomSheetModalRef, ...bottomSheetProps } =
      useGeneralBottomSheetModal({
        show: isVisible,
        minSnapPoint: '40%',
        mediumSnapPoint: '75%',
        index: 1,
        onDismiss,
      });

    const animatedPosition = useSharedValue(0);
    const height = useGeneralBottomSheetHeight();
    const style = useAnimatedStyle(() => {
      return {
        opacity: interpolate(
          animatedPosition.value,
          [(height * 2) / 4, height],
          [1, 0],
        ),
      };
    });

    const source = useTermsOfServiceHtmlSource();

    const Footer = useCallback(
      (props: BottomSheetFooterProps) => {
        return (
          <BottomSheetFooter {...props}>
            <BottomAction style={style}>
              <BottomAction.Button text="确认" onPress={onConfirm} />
            </BottomAction>
          </BottomSheetFooter>
        );
      },
      [onConfirm, style],
    );
    return (
      <BottomSheetModal
        ref={bottomSheetModalRef}
        {...bottomSheetProps}
        footerComponent={Footer}
        animatedPosition={animatedPosition}
      >
        <View
          css={`
            flex: 1;
            padding-bottom: ${rpx(110)}px;
          `}
        >
          <WebContent
            showsVerticalScrollIndicator={false}
            css={`
              flex: 1;
            `}
            containerStyle={{
              paddingLeft: rpx(15),
              paddingRight: rpx(15),
            }}
            source={source}
          />
        </View>
      </BottomSheetModal>
    );
  },
);
